module.exports = __webpack_public_path__ + "static/media/madame-destiny-megaways.065f9ef5.gif";